import "./styles.scss";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

import { useTask } from "context/admin/task";
import { useTaskView } from "context/admin/task_view";

import ModalNew from "components/ModalNew";
import Calendar from "components/Calendar";
import Button from "components/Button";

const mainClass = "task-view-main-tracker-edit";

const ModalEdit = ({ data, isOpen, onClose }) => {
  const { t } = useTranslation();
  const { updateTaskTime } = useTask();
  const { refetch } = useTaskView();

  const { id, date, time } = data || {};

  const [selectedDate, setSelectedDate] = useState(undefined);
  const [selectedTime, setSelectedTime] = useState("");
  const [isTimeFocused, setIsTimeFocused] = useState(false);
  const [loading, setLoading] = useState(false);

  const convertTimeToNumber = (input) => {
    const value = input.trim();

    if (!value) {
      return "";
    }

    if (/^\d+\.?\d*$/.test(value)) {
      return value;
    }

    const timePattern =
      /(\d+\.?\d*)\s*(h|g|hours?|min|m|minutes?|s|sec|seconds?)/gi;
    const matches = [...value.matchAll(timePattern)];

    if (matches.length === 0) {
      return "";
    }

    let totalMinutes = 0;

    matches.forEach((match) => {
      const num = parseFloat(match[1]);
      const unit = match[2].toLowerCase();

      if (unit.startsWith("h") || unit.startsWith("g")) {
        totalMinutes += num * 60;
      } else if (unit.startsWith("m")) {
        totalMinutes += num;
      } else if (unit.startsWith("s")) {
        totalMinutes += num / 60;
      }
    });

    return totalMinutes.toFixed(2);
  };

  const handleTimeBlur = () => {
    const converted = convertTimeToNumber(selectedTime);
    setSelectedTime(converted);
    setIsTimeFocused(false);
  };

  const handleTimeChange = (e) => {
    const value = e.target.value;

    if (/^[\d\s.hgmins]*$/i.test(value)) {
      setSelectedTime(value);
    }
  };

  const handleClose = () => {
    if (typeof onClose === "function") onClose();

    setSelectedDate(undefined);
    setSelectedTime("");
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      let new_time = {
        hours: null,
        minutes: null,
        seconds: null,
      };

      if (selectedTime && selectedTime.trim() !== "") {
        const totalMinutes = parseFloat(selectedTime);
        const hours = Math.floor(totalMinutes / 60);
        const minutes = Math.floor(totalMinutes % 60);
        const seconds = Math.round((totalMinutes % 1) * 60);

        new_time = {
          hours: hours,
          minutes: minutes,
          seconds: seconds,
        };
      }

      await updateTaskTime(id.time, {
        new_time,
        created_at: selectedDate ?? "",
        webmaster: [id.webmaster],
      });
      await refetch(true);

      if (typeof onClose === "function") onClose();

      setSelectedDate(undefined);
      setSelectedTime("");
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };

  return (
    <ModalNew
      title={t("Edit work time")}
      variant="small"
      isOpen={isOpen}
      isSubmitHidden
      onClose={handleClose}
    >
      <div className={mainClass}>
        <div className={`${mainClass}__field`}>
          <p>{t("Current")}</p>
          <div className={`${mainClass}__field-row`}>
            <div>
              <p>{date}</p>
            </div>
            <div>
              <p>{time}</p>
            </div>
          </div>
        </div>
        <div className={`${mainClass}__field ${mainClass}__field--new`}>
          <p>{t("New")}</p>
          <div className={`${mainClass}__field-row`}>
            <div>
              <div className={`${mainClass}__date`}>
                <p>
                  {selectedDate
                    ? moment(selectedDate).format("LL")
                    : t("Select date")}
                </p>
                <Calendar
                  only_icon
                  close_icon
                  default_value={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                />
              </div>
            </div>
            <div>
              <input
                className={`${mainClass}__input`}
                type="text"
                placeholder={t("Time")}
                value={selectedTime}
                onChange={handleTimeChange}
                onFocus={() => setIsTimeFocused(true)}
                onBlur={handleTimeBlur}
              />
            </div>
          </div>
        </div>
        <div className={`${mainClass}__cta`}>
          <Button
            disabled={
              (!selectedDate && selectedTime === "") || isTimeFocused || loading
            }
            onClick={handleSubmit}
          >
            {t("Update")}
          </Button>
        </div>
      </div>
    </ModalNew>
  );
};

export default ModalEdit;
